module.exports = __webpack_public_path__ + "img/biaoti.02cde189.png";